<style scoped>
.mmt-section+.mmt-section {
  margin-top: 18px;
}

.mmt-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #7E8299;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 0 4px 8px;
}

.mmt-group {
  margin-bottom: 2px;
}

.mmt-group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 4px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s ease;
}

.mmt-group-header:active {
  background: #F5F8FA;
}

.mmt-group-ic {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mmt-group-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #3F4254;
}

.mmt-chev {
  transition: transform 0.2s ease;
  color: #B5B5C3 !important;
}

.mmt-chev.open {
  transform: rotate(180deg);
}

.mmt-group-body {
  padding-left: 26px;
  border-left: 1px dashed #E4E6EF;
  margin-left: 10px;
}
</style>

<template>
  <div class="mmt-list">
    <template v-for="(item, idx) in items">
      <div v-if="item.has_children && item.children && item.children.length" :key="'grp-' + idx"
        :class="sectionHeaders ? 'mmt-section' : 'mmt-group'">
        <template v-if="sectionHeaders">
          <div class="mmt-section-label">{{ item.name }}</div>
          <MegaMenuTree :items="item.children" :section-headers="false" :pass-props="passProps"
            @to_close_MenuDialog="$emit('to_close_MenuDialog')" />
        </template>
        <template v-else>
          <div class="mmt-group-header" @click="toggle(idx)">
            <span class="mmt-group-ic">
              <v-icon v-if="isMdiIcon(item.icon)" size="16" color="#7E8299">{{ item.icon }}</v-icon>
            </span>
            <span class="mmt-group-name">{{ item.name }}</span>
            <v-icon size="18" class="mmt-chev" :class="{ open: isOpen(idx) }">mdi-chevron-down</v-icon>
          </div>
          <div v-show="isOpen(idx)" class="mmt-group-body">
            <MegaMenuTree :items="item.children" :section-headers="false" :pass-props="passProps"
              @to_close_MenuDialog="$emit('to_close_MenuDialog')" />
          </div>
        </template>
      </div>
      <SideBarMenu v-else :key="'leaf-' + idx" v-bind="passProps" :ItemObj="item" type_menu="Item_List_Menu_LEFTSide"
        @to_close_MenuDialog="$emit('to_close_MenuDialog')" />
    </template>
  </div>
</template>

<script>
import SideBarMenu from "@/components/Menu/SideBarMenu.vue";
import { isMdiIcon } from "./megaMenuData";

export default {
  name: "MegaMenuTree",
  components: { SideBarMenu },
  props: {
    items: { type: Array, default: () => [] },
    // true: children render as always-open, uppercase section labels
    // (e.g. Activate -> "Process Design" / "Management Systems").
    // false: children with their own children render as a collapsed,
    // tap-to-expand disclosure row instead, so deep trees (e.g. FMS masters)
    // stay compact.
    sectionHeaders: { type: Boolean, default: false },
    passProps: { type: Object, default: () => ({}) },
  },
  data() {
    return { openMap: {} };
  },
  methods: {
    isMdiIcon,
    toggle(key) {
      this.$set(this.openMap, key, !this.openMap[key]);
    },
    isOpen(key) {
      return !!this.openMap[key];
    },
  },
};
</script>
